import * as v from './field-validations';
import * as c from './form-constants';

// General Field Types
export const text = {
  validations: v.validateBasicField
};

export const select = {
  validations: v.validateSelect
};

// Specific Field Types

export const firstName = {
  name: c.FIRST_NAME,
  validations: v.validateFirstName
};

export const lastName = {
  name: c.LAST_NAME,
  validations: v.validateLastName
};

export const email = {
  name: c.EMAIL,
  sanitize: val => val?.trim(),
  validations: v.validateEmail
};

export const phone = {
  name: c.PHONE,
  validations: v.validatePhone
};

export const phoneType = {
  name: c.PHONE_TYPE,
  validations: v.validatePhoneType
};

export const addressLine1 = {
  name: c.ADDRESS_LINE_1,
  validations: v.validateAddressLine1
};

export const addressLine2 = {
  isRequired: false,
  name: c.ADDRESS_LINE_2,
  validations: v.validateAddressLine2
};

export const country = {
  name: c.COUNTRY,
  validations: v.validateCountry
};

export const zip = {
  name: c.ZIP,
  validations: v.validateZip
};

export const city = {
  name: c.CITY,
  validations: v.validateCity
};

export const state = {
  name: c.STATE,
  validations: v.validateState
};

export const password = {
  name: c.PASSWORD,
  validations: v.validatePassword
};

export const creditCard = {
  name: c.CREDIT_CARD,
  validations: v.validateCreditCard
};

export default {
  addressLine1,
  addressLine2,
  city,
  country,
  creditCard,
  email,
  firstName,
  lastName,
  password,
  phone,
  phoneType,
  state,
  text,
  zip
};
